module.exports = __webpack_public_path__ + "static/nasi-ludzie.87932cdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/nasi-ludzie.jpg
// module id = 701
// module chunks = 196067925415476